import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { CandidateStatusMap, TalentType } from "./types"

type TalentGridProps = {
  talents: TalentType[]
  onViewProfile: (id: string) => void
}

export function TalentGrid({ talents, onViewProfile }: TalentGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {talents.map(talent => (
        <Card onClick={() => onViewProfile(talent._id)} key={talent._id} className="overflow-hidden hover:shadow-md transition-shadow cursor-pointer">
          <CardHeader className="pb-2">
            <div className="flex justify-between items-start">
              <div>
                <CardTitle>{talent.name}</CardTitle>
                <p className="text-sm text-gray-500">{talent.level} {talent.position}</p>
              </div>
              <Badge className={`
                ${talent.status === "Available" 
                  ? "bg-green-100 text-green-800 hover:bg-green-200" 
                  : talent.status === "In process" 
                    ? "bg-blue-100 text-blue-800 hover:bg-blue-200" 
                    : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                } transition-colors`
              }>
                {CandidateStatusMap[talent.status]}
              </Badge>
            </div>
          </CardHeader>
          <CardContent className="pb-2">
            <div className="space-y-3">
              <div className="flex flex-row items-baseline gap-2">
                <p className="text-sm font-medium">Skills</p>
                <div className="flex flex-wrap gap-1 mt-1">
                  {talent.skills.map((skill) => (
                    <Badge key={skill} variant="outline" className="text-xs">
                      {skill}
                    </Badge>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-sm font-medium">Languages</p>
                <p className="text-sm">{talent.languages.map(lang => lang.language).join(", ")}</p>
              </div>
            </div>
          </CardContent>
          <CardFooter className="border-t pt-4 flex justify-between text-xs text-gray-500">
            <p>Last updated: {new Date(talent.updatedAt).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}</p>
          </CardFooter>
        </Card>
      ))}
    </div>
  )
} 